// extracted by mini-css-extract-plugin
export default {"module-list":"ModuleList_module-list__mFqXn","favorite":"ModuleList_favorite__02kjU","has-border-top":"ModuleList_has-border-top__GQA25"};